import React, { useState } from 'react'

import { Popover } from 'rsuite'
const SearchCategoryModal = ({ categoryList, currentCategory, onTabChange }) => {
    const [currentTab, setCurrentTab] = useState(currentCategory)
    const handleClickTab = (tab) => {
        setCurrentTab(tab)
        onTabChange(tab)
    }
    return (
        <div>
            <Popover title="" className='search-category-popover' visible>
                <div className="search-category-tabs flex flex-column">
                    {
                        categoryList.map(tab => (
                            <button
                                key={tab.value}
                                type="button"
                                className={`search-category-tab${currentTab === tab.value ? ' selected' : ''}`}
                                onClick={() => { handleClickTab(tab.value) }}
                            >
                                {tab.label}
                            </button>
                        ))
                    }
                </div>
            </Popover>
        </div>
    )
}

export default SearchCategoryModal;